const Maze = require('../model/maze');
const maze1 = require('../../../data/mazes/explore-exploit.json');
const training = require('../../../data/training/explore-exploit.json');
const Robot = require('../model/robot');
const QLearningAI = require('../model/qlearning-ai');
const MazeView = require('../view-pixi/maze-view');
const AITrainingView = require('../view-html/ai-training-view');
const RobotView = require('../view-pixi/robot-view');

class ExploreExploitInteractive {
  constructor(config, textures) {
    const maze = Maze.fromJSON(maze1);
    maze.config = config;
    this.robot = new Robot();
    maze.addRobot(this.robot);
    this.ai = new QLearningAI(maze.robot);
    this.ai.learningRate = 0;
    this.ai.exploreRate = 0;
    this.ai.q = training.q;

    this.view = new MazeView(maze, config, textures);
    this.ui = new AITrainingView(this.ai, this.view.robotView);
    this.view.robotView.setSpeed(RobotView.Speed.SLOW);
    this.ui.running = true;
    this.ui.robotIdle = false;
    this.ai.step();
  }

  getDisplayObject() {
    return this.view.displayObject;
  }

  animate(time) {
    this.view.animate(time);
  }
}

module.exports = ExploreExploitInteractive;
